// Meertaligheid. Eén functie t(sleutel, waarden) voor code, en data-i18n
// attributen voor vaste teksten in body.html:
//   data-i18n="sleutel"              vervangt de tekst van het element
//   data-i18n-placeholder="sleutel"  vervangt de placeholder
//   data-i18n-title="sleutel"        vervangt de tooltip
//
// De keuze staat per browser in localStorage. Ontbreekt een vertaling, dan
// valt t() terug op Nederlands en daarna op de sleutel zelf; tests/i18n.mjs
// zorgt dat dat in de praktijk niet gebeurt.
import nl from '../i18n/nl.js';
import en from '../i18n/en.js';

export const TALEN = { nl: { naam: 'Nederlands', teksten: nl }, en: { naam: 'English', teksten: en } };
const OPSLAG = 'tornema_taal';

function beginTaal() {
  try {
    const opgeslagen = localStorage.getItem(OPSLAG);
    if (opgeslagen && TALEN[opgeslagen]) return opgeslagen;
  } catch { /* geen opslag beschikbaar */ }
  const browser = (typeof navigator !== 'undefined' && navigator.language || '').slice(0, 2).toLowerCase();
  return TALEN[browser] ? browser : 'nl';
}

let huidig = beginTaal();

export const taal = () => huidig;

// Datum- en getalnotatie volgen de taal.
export const locale = () => (huidig === 'en' ? 'en-GB' : 'nl-NL');

export function t(sleutel, waarden) {
  const tekst = TALEN[huidig].teksten[sleutel] ?? nl[sleutel] ?? sleutel;
  if (!waarden) return tekst;
  return tekst.replace(/\{(\w+)\}/g, (_, k) => (waarden[k] ?? `{${k}}`));
}

export function vertaalDom(root = document) {
  root.querySelectorAll('[data-i18n]').forEach(el => { el.textContent = t(el.dataset.i18n); });
  root.querySelectorAll('[data-i18n-placeholder]').forEach(el => { el.placeholder = t(el.dataset.i18nPlaceholder); });
  root.querySelectorAll('[data-i18n-title]').forEach(el => { el.title = t(el.dataset.i18nTitle); });
  document.documentElement.lang = huidig;
}

// Wisselt de taal, vertaalt de vaste teksten en laat pagina's weten dat ze
// opnieuw moeten tekenen (event 'taalgewijzigd' op document).
export function zetTaal(code) {
  if (!TALEN[code] || code === huidig) return;
  huidig = code;
  try { localStorage.setItem(OPSLAG, code); } catch { /* niet bewaard, wel gewisseld */ }
  vertaalDom();
  document.querySelectorAll('select[data-taalkeuze]').forEach(s => { s.value = code; });
  document.dispatchEvent(new CustomEvent('taalgewijzigd', { detail: code }));
}

// Koppelt elke <select data-taalkeuze> aan zetTaal. Geen inline handler: dit
// is nieuwe code en die hangt niet aan de globale App.
export function koppelTaalkeuze(root = document) {
  root.querySelectorAll('select[data-taalkeuze]').forEach(s => {
    if (s.dataset.gekoppeld) return;
    s.innerHTML = Object.entries(TALEN)
      .map(([code, { naam }]) => `<option value="${code}">${naam}</option>`).join('');
    s.value = huidig;
    s.addEventListener('change', () => zetTaal(s.value));
    s.dataset.gekoppeld = '1';
  });
}
